import React from 'react';
import { formatDescriptions } from '../utils/utils';
import { styles } from './ExtraDescription.css';

export type ExtraDescriptionProps = {
  softwareFormat?: string;
  consumerAdvice: string;
  ageRating: string;
  releaseDateFormatted: string;
  isReleaseDateInPast: boolean;
  requiresExtraDescriptions: any;
  isPreOrder: boolean;
  highlight?: string;
};

export const ExtraDescription = ({
  softwareFormat,
  ageRating,
  consumerAdvice,
  releaseDateFormatted,
  isReleaseDateInPast,
  requiresExtraDescriptions,
  highlight,
  isPreOrder,
}: ExtraDescriptionProps): JSX.Element => {
  const sanitizedShortDescription = highlight ? formatDescriptions(highlight) : '';

  return (
    <div className={styles.extraDescriptionContainer}>
      {requiresExtraDescriptions ? (
        <div className={styles.shortDescription} dangerouslySetInnerHTML={{ __html: sanitizedShortDescription }}></div>
      ) : null}
      <ul>
        {softwareFormat ? (
          <li>
            <span className={styles.descriptionTitle}>Format: </span>
            <span className={styles.description}>{softwareFormat}</span>
          </li>
        ) : null}
        {ageRating && requiresExtraDescriptions ? (
          <li>
            <span className={styles.descriptionTitle}>Rating: </span>
            <span className={styles.description}>{ageRating}</span>
          </li>
        ) : null}
        {consumerAdvice && requiresExtraDescriptions ? (
          <li>
            <span className={styles.descriptionTitle}>Consumer Advice: </span>
            <span className={styles.description}>{consumerAdvice}</span>
          </li>
        ) : null}
        {isReleaseDateInPast && !isPreOrder ? (
          <li>
            <span className={styles.descriptionTitle}>Release Date: </span>
            <span className={styles.description}>{releaseDateFormatted}</span>
          </li>
        ) : null}
      </ul>
    </div>
  );
};

export default ExtraDescription;
